// Error toasts. `auth` and `unauthorized` are reported by ApiCall itself (see App.js).
export const ERRORS = {
    auth: 'Your session could not be renewed. Please log in again.',
    unauthorized: 'You are not authorized for this action. Please log in again.',
    loadLinesAndCountries: 'The lines and countries could not be loaded.',
    loadCities: 'The cities could not be loaded.',
    copyLines: 'The lines could not be copied.',
    loadLineList: 'The line list could not be loaded.',
    search: 'The search failed. Please try again.',
    downloadExcel: 'The Excel file could not be downloaded.',
    loadRequests: 'The requests could not be loaded.',
    loadRequest: 'The request could not be loaded.',
    uploadDocuments: 'The documents could not be uploaded.',
    deleteDocument: 'The document could not be deleted.',
    changeStatus: 'The status could not be changed.',
    confirmPii: 'Your confirmation could not be saved.',
};
